import React from "react";
import PropTypes from 'prop-types';
import { Button as NBButton, useColorModeValue, useContrastText, } from "native-base"

import { Icon } from "../Icon"
import { Box } from "~/native-ui/native-base";
import { extractNativeProps } from "~/native-ui/utils";
import { CountBadge } from "~/native-ui/Badge";

const ButtonWithContrastText = React.forwardRef((props, ref) => {
    const defaultColorValue = useColorModeValue("darkText", "lightText");
    const colorScheme = props.colorScheme ?? "primary";
    const colorToken = `${colorScheme}.500`;

    const color = ({
        solid : useContrastText(colorToken, props.color) || defaultColorValue,
    })[props.variant];

    const buttonProps = {
        ...props,
        _text: {
            ...(props._text || {}),
            color
        },
        color
    }
    
    return (
        <NBButton ref={ref} { ...buttonProps }></NBButton>
    )
})

export const Button = (() => {
    class Button extends React.Component {
        static propTypes = {
            children: PropTypes.node,
            className: PropTypes.string,
            disabled: PropTypes.bool,
            href: PropTypes.string,
    
            // mini: PropTypes.bool,
    
            // floating: PropTypes.bool,
            // inverse: PropTypes.bool,
            // neutral: PropTypes.bool,
            // onMouseUp: PropTypes.func,
            // raised: PropTypes.bool,
    
            variant: PropTypes.string,
            badge: PropTypes.oneOfType([
                PropTypes.number,
                PropTypes.bool,
            ]),
            colorScheme: PropTypes.string,
            label: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.node,
            ]),
            iconSize: PropTypes.string,
            iconFamily: PropTypes.string,
            icon: PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.element,
              PropTypes.node,
            ]),
    
            primary: PropTypes.bool,
            onMouseLeave: PropTypes.func,
            onPress: PropTypes.func,
            onClick: PropTypes.func,
            type: PropTypes.string,
            containerProps: PropTypes.any,
        };
      
        static defaultProps = {
            // accent: false,
            // className: '',
            // iconClassName: '',
            // flat: false,
            // floating: false,
            // mini: false,
            // neutral: true,
            // raised: false,
            iconSize: "xs",
    
            primary: false,
            type: 'button',
        };
    
        get colorScheme() {
            return this.props.primary ? "primary" : this.props.colorScheme
        }
    
        get variant() {
            return this.props.ghost ? "ghost_faded" : this.props.variant;
        }
        
        render() {
            const [ uiProps, componentProps ] = extractNativeProps(this.props);
            const { badge, icon, disabled, iconSize, onClick, onPress, onMouseLeave, children = null, label = null, rightIcon, iconFamily, forwardRef, _stack, badgeProps, containerProps = {}, ...other } = componentProps;
    
    
            const iconProps = {
                size: iconSize,
                ...this.props.iconProps,
            }

            const props = {
                ...uiProps,
                ...other,
                _stack: _stack ?? { space: [children, label, icon, rightIcon].filter(Boolean).length > 1 ? undefined : "0" },
                ref: forwardRef,
                position: "relative",
                variant: this.variant,
                colorScheme: this.colorScheme,
                onPress: onPress || onClick,
                onHoverOut: onMouseLeave,
                isDisabled: disabled,
                startIcon: icon ? <Icon iconFamily={iconFamily} { ...iconProps } type={ icon } /> : null,
                endIcon: rightIcon ? <Icon iconFamily={iconFamily} { ...iconProps } type={ rightIcon } /> : null
            }
    
            return (
                <Box {...containerProps}>
                    <CountBadge count={ badge || 0 } {...badgeProps} />
                    <ButtonWithContrastText { ...props } badge>
                        { label || null }
                        { children || null }
                    </ButtonWithContrastText>
                </Box>
            )
        }
    }

    return React.forwardRef((props, ref) => <Button forwardRef={ref} { ...props } />)
})()


Button.ButtonGroup = NBButton.Group